// extracted by mini-css-extract-plugin
export default {"pageWrapper":"RecipeVariantFormScreen_pageWrapper__lAvGj","loading":"RecipeVariantFormScreen_loading__k262P","error":"RecipeVariantFormScreen_error__VNtuV"};